/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFLocale } from './CRSFLocale';
import {
    CRSFLocaleFromJSON,
    CRSFLocaleFromJSONTyped,
    CRSFLocaleToJSON,
} from './CRSFLocale';
import type { CRSFScanType } from './CRSFScanType';
import {
    CRSFScanTypeFromJSON,
    CRSFScanTypeFromJSONTyped,
    CRSFScanTypeToJSON,
} from './CRSFScanType';
import type { CRSFStatusType } from './CRSFStatusType';
import {
    CRSFStatusTypeFromJSON,
    CRSFStatusTypeFromJSONTyped,
    CRSFStatusTypeToJSON,
} from './CRSFStatusType';
import type { Metrics } from './Metrics';
import {
    MetricsFromJSON,
    MetricsFromJSONTyped,
    MetricsToJSON,
} from './Metrics';

/**
 * 
 * @export
 * @interface CRSFProcessShort
 */
export interface CRSFProcessShort {
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessShort
     */
    created: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFProcessShort
     */
    domains?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFProcessShort
     */
    entity_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFProcessShort
     */
    entity_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFProcessShort
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFProcessShort
     */
    issue?: string;
    /**
     * 
     * @type {CRSFLocale}
     * @memberof CRSFProcessShort
     */
    locale?: CRSFLocale;
    /**
     * 
     * @type {{ [key: string]: Metrics; }}
     * @memberof CRSFProcessShort
     */
    metrics?: { [key: string]: Metrics; };
    /**
     * 
     * @type {boolean}
     * @memberof CRSFProcessShort
     */
    no_result_flag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFProcessShort
     */
    original_process_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFProcessShort
     */
    process_id: string;
    /**
     * 
     * @type {CRSFStatusType}
     * @memberof CRSFProcessShort
     */
    process_status: CRSFStatusType;
    /**
     * 
     * @type {CRSFScanType}
     * @memberof CRSFProcessShort
     */
    scan_type: CRSFScanType;
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessShort
     */
    updated: number;
}

/**
 * Check if a given object implements the CRSFProcessShort interface.
 */
export function instanceOfCRSFProcessShort(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "process_status" in value;
    isInstance = isInstance && "scan_type" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function CRSFProcessShortFromJSON(json: any): CRSFProcessShort {
    return CRSFProcessShortFromJSONTyped(json, false);
}

export function CRSFProcessShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFProcessShort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'created': json['created'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'entity_logo_url': !exists(json, 'entity_logo_url') ? undefined : json['entity_logo_url'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'issue': !exists(json, 'issue') ? undefined : json['issue'],
        'locale': !exists(json, 'locale') ? undefined : CRSFLocaleFromJSON(json['locale']),
        'metrics': !exists(json, 'metrics') ? undefined : (mapValues(json['metrics'], MetricsFromJSON)),
        'no_result_flag': !exists(json, 'no_result_flag') ? undefined : json['no_result_flag'],
        'original_process_id': !exists(json, 'original_process_id') ? undefined : json['original_process_id'],
        'process_id': json['process_id'],
        'process_status': CRSFStatusTypeFromJSON(json['process_status']),
        'scan_type': CRSFScanTypeFromJSON(json['scan_type']),
        'updated': json['updated'],
    };
}

export function CRSFProcessShortToJSON(value?: CRSFProcessShort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created': value.created,
        'domains': value.domains,
        'entity_logo_url': value.entity_logo_url,
        'entity_name': value.entity_name,
        'ip_addresses': value.ip_addresses,
        'issue': value.issue,
        'locale': CRSFLocaleToJSON(value.locale),
        'metrics': value.metrics === undefined ? undefined : (mapValues(value.metrics, MetricsToJSON)),
        'no_result_flag': value.no_result_flag,
        'original_process_id': value.original_process_id,
        'process_id': value.process_id,
        'process_status': CRSFStatusTypeToJSON(value.process_status),
        'scan_type': CRSFScanTypeToJSON(value.scan_type),
        'updated': value.updated,
    };
}

